import { Link } from "wouter";

import { cn } from "@/lib/utils.ts";
import { userTaskLabelHref } from "@/types/userTaskLinks.ts";
import type { UserTask } from "@/types/userTasks.ts";

/**
 * One of a task's labels, as a link to that label's list.
 *
 * Its own chip rather than a `Badge`: a badge is a `div` with no size this
 * small, and the chip is an anchor so middle-click and hover-preview work. The
 * row and the detail page draw it from here so the two cannot drift.
 */
export const LabelChip = ({
  label,
  statsigName,
  className,
}: {
  label: NonNullable<UserTask["labels"]>[number];
  statsigName: string;
  className?: string;
}) => (
  <Link
    href={userTaskLabelHref(label.id)}
    className={cn(
      "rounded-3xl border px-2 py-0.5 text-xs text-muted-foreground hover:bg-secondary",
      className,
    )}
    data-label={label.name}
    data-statsig-name={statsigName}
  >
    {label.name}
  </Link>
);
